// @ts-check
import React from "react";
import { AuthModals } from "../config/const";
import LoginModal from "../views/components/authModals/LoginModal";
import MobileNumberModal from "../views/components/authModals/MobileNumberModal";
import MobileNumberVerifyModal from "../views/components/authModals/MobileNumberVerifyModal";
import RegisterModal from "../views/components/authModals/RegisterModal";
import ForgotPasswords from "../views/components/authModals/ForgotPassword";
import ResetPassword from "../views/components/authModals/ResetPassword";

/**
 *
 * @param {{activeModal:string | null , agentCode:string | null}} param0
 * @returns {React.ReactNode}
 */
const ModalWrapper = ({ activeModal, agentCode }) => {
  return (
    <>
      {activeModal === AuthModals.Login && (
        <LoginModal show={activeModal === AuthModals.Login} />
      )}
      {activeModal === AuthModals.MobileNumber && (
        <MobileNumberModal show={activeModal === AuthModals.MobileNumber} />
      )}

      {activeModal === AuthModals.VerifyNumber && (
        <MobileNumberVerifyModal
          show={activeModal === AuthModals.VerifyNumber}
        />
      )}
      {activeModal === AuthModals.Register && (
        <RegisterModal
          show={activeModal === AuthModals.Register}
          agentCode={agentCode}
        />
      )}
      {activeModal === AuthModals.ForgotPassword && (
        <ForgotPasswords show={activeModal === AuthModals.ForgotPassword} />
      )}
      {activeModal === AuthModals.ResetPassword && (
        <ResetPassword show={activeModal === AuthModals.ResetPassword} />
      )}
    </>
  );
};
export default ModalWrapper;
